import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import filesystemapi from "../services/filesystem";

export const fetchTransferByToken = createAsyncThunk(
  "transfer/fetchByToken",
  async ({ accessToken, reCaptchaToken }, { rejectWithValue }) => {
    try {
      const res = await filesystemapi.post(
        `/Shares/by-access-token/${accessToken}`,
        JSON.stringify(reCaptchaToken),
        { headers: { "Content-Type": "application/json" } }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.ExceptionMessage || "Transfer bulunamadı."
      );
    }
  }
);

export const downloadTransferFile = createAsyncThunk(
  "transfer/download",
  async ({ accessToken, password, fallbackFilename, reCaptchaToken }, { rejectWithValue }) => {
    try {
      const res = await filesystemapi.post(
        `/Shares/download/${accessToken}`,
        { password: password || null, reCaptchaToken },
        {
          responseType: "blob",
          headers: { "Content-Type": "application/json" },
        }
      );

      // Try to extract filename from Content-Disposition header, fallback to file's real name
      const disposition = res.headers["content-disposition"] || "";
      let filename = fallbackFilename || "download";
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
      if (match) filename = match[1].replace(/['"]/g, "").trim();

      // Use the actual content-type from the response
      const contentType = res.headers["content-type"] || "application/octet-stream";

      // Trigger browser download
      const url = window.URL.createObjectURL(new Blob([res.data], { type: contentType }));
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return filename;
    } catch (err) {
      let message = "İndirme başarısız oldu.";
      if (err.response?.data instanceof Blob) {
        try {
          const text = await err.response.data.text();
          const json = JSON.parse(text);
          message = json?.ExceptionMessage || message;
        } catch {
          // ignore parse error
        }
      }
      return rejectWithValue(message);
    }
  }
);

const transferSlice = createSlice({
  name: "transfer",
  initialState: {
    data: null,
    loading: false,
    error: null,
    downloading: false,
    downloadError: null,
  },
  reducers: {
    resetTransfer: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.downloading = false;
      state.downloadError = null;
    },
    clearDownloadError: (state) => {
      state.downloadError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransferByToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransferByToken.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchTransferByToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(downloadTransferFile.pending, (state) => {
        state.downloading = true;
        state.downloadError = null;
      })
      .addCase(downloadTransferFile.fulfilled, (state) => {
        state.downloading = false;
      })
      .addCase(downloadTransferFile.rejected, (state, action) => {
        state.downloading = false;
        state.downloadError = action.payload;
      });
  },
});

export const { resetTransfer, clearDownloadError } = transferSlice.actions;
export default transferSlice.reducer;
